

export interface ProcedenciaValues {
  Pais: string;
  CodigoPais: string;
  ProvinciaContacto: string;
  CodProvincia: string;
  CodCiudad: string;
  Ciudad: string;
}

export interface FormularioCompraResponse {
  datosCompra: DatosCompra[]
  datosCompraControl: DatosCompraControl[]
  datosCompraPoliticaControl: DatosCompraPoliticaControl[]
  datosFactura: DatosFactura[]
}

export interface DatosCompra {
  name: string
  label: string
  type: string
  inputType: string
  required: boolean
  visible: boolean
  maximo?: number
  format: string
  equal: string
  dependence: string
  optionsJSON: OptionsJson[]
  busqueda: any
  value: any
}

export interface OptionsJson {
  nombre: string
  value: string
}

export interface DatosCompraControl {
  name: string
  label: string
  type: string
  inputType: string
  required: boolean
  visible: boolean
  maximo: number
  format: string
  equal: string
  dependence: string
  optionsJSON: any[]
  busqueda?: Busqueda
  value: any
}

export interface Busqueda {
  incluirContactos: any
  campo: any
}

export interface DatosCompraPoliticaControl {
  politica: any
  enlace: string
  nombreproyecto: string
  nombreformulario: string
  publicidadinterna: any
  name: string
  label: string
  type: string
  inputType: string
  required: boolean
  visible: boolean
  maximo: number
  format: string
  equal: string
  dependence: string
  optionsJSON: any[]
  busqueda: any
  value: any
}

export interface DatosFactura {
  type: string
  label: string
  inputType?: string
  name: string
  required: boolean
  visible: boolean
  maximo: number
  optionsJSON: OptionsJson[]
  dependence?: string
  value?: boolean
  referenceDepedence: string
  referenceName: string
}

export interface FormularioCompraParams {
  conexionId?: string
  plataforma?: number
  enlaceMenuId?: string
  localizador?: string
  cI_Usuario?: string
  cI_Contrasena?: string
}

export enum PayMethodEnum {
  IN = "IN",
  PS = "PS",
  PG = "PG",
  PP = "PP",
  BZ = "BZ",
  SP = "SP"
}